var _circle, _circle2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F7F8FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 14,
    fill: "#0516C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 22.875C19.5 22.875 20.25 22.875 21 24.375C21 24.375 23.3827 20.625 25.5 19.875M13.125 17.625H13.1182M17.25 23.625H16.875C14.0557 23.625 12.6465 23.625 11.7052 22.8825C11.5557 22.764 11.4166 22.6328 11.2897 22.4902C10.5 21.6052 10.5 20.2777 10.5 17.625C10.5 14.9723 10.5 13.6455 11.2897 12.7598C11.4162 12.6178 11.5547 12.4873 11.7052 12.3683C12.6465 11.625 14.0557 11.625 16.875 11.625H19.125C21.9442 11.625 23.3535 11.625 24.294 12.3675C24.445 12.4875 24.5837 12.6183 24.7102 12.7598C25.422 13.5578 25.4925 14.7135 25.5 16.875V17.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.875 17.625C19.875 18.1223 19.6775 18.5992 19.3258 18.9508C18.9742 19.3025 18.4973 19.5 18 19.5C17.5027 19.5 17.0258 19.3025 16.6742 18.9508C16.3225 18.5992 16.125 18.1223 16.125 17.625C16.125 17.1277 16.3225 16.6508 16.6742 16.2992C17.0258 15.9475 17.5027 15.75 18 15.75C18.4973 15.75 18.9742 15.9475 19.3258 16.2992C19.6775 16.6508 19.875 17.1277 19.875 17.625Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.0446397ff67ab83778862b0ac1ddeec3.svg";
export { ForwardRef as ReactComponent };